export function timeAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const s = (Date.now() - d.getTime()) / 1000;
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function timeUntil(iso) {
  if (!iso) return { text: "—", breached: false };
  const target = new Date(iso).getTime();
  const diff = (target - Date.now()) / 1000;
  const abs = Math.abs(diff);
  let text;
  if (abs < 3600) text = `${Math.floor(abs / 60)}m`;
  else if (abs < 86400) text = `${Math.floor(abs / 3600)}h ${Math.floor((abs % 3600) / 60)}m`;
  else text = `${Math.floor(abs / 86400)}d ${Math.floor((abs % 86400) / 3600)}h`;
  return { text: diff >= 0 ? `${text} left` : `${text} overdue`, breached: diff < 0 };
}

export function initials(name = "") {
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase() || "?";
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  const days = Math.floor(s / 86400);
  const hrs = Math.floor((s % 86400) / 3600);
  return hrs > 0 ? `${days}d ${hrs}h` : `${days}d`;
}
